import * as React from "react";
import Box from "@mui/material/Box";
import { Dialog, DialogContent } from "@mui/material";
import { Formik } from "formik";
import { useEffect } from "react";
import Styles from "./Payment.module.scss";
import { closeToast } from "../NotificationToast";
import {
  closeOrder,
  checkHospital,
} from "../../redux/orders/actions/orders.actions";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { SelectField } from "../Form/SelectField";
import Reason from "./Reason";
import { IssuesCloseOutlined } from "@ant-design/icons";

const paymentMode = [
  { value: "bank transfer", label: "BANK TRANSFER" },
  { value: "cash", label: "Cash on Delivery" },
  { value: "transfer", label: "Bank Transfer" },
  { value: "cheque", label: "Cheque" },
  { value: "boat", label: "BOAT" },
  { value: "hmo", label: "HMO" },
  { value: "hospital cancelled", label: "Hospital Cancelled" },
];

export default function PaymentDetails(props) {
  const [payments, setPayment] = React.useState("");
  const [reason, setReason] = React.useState(false);
  const checker = useSelector((state) => state.orderReducer.checker);
  const dispatch = useDispatch();
  const [podFile, setPodFile] = React.useState(null);

  const handleFileChange = (event, setFieldValue) => {
    const file = event.target.files?.[0];
    if (file) {
      setPodFile(file);
      setFieldValue("pod", file);
    }
  };

  // console.log("checker", checker);
  // console.log("props", props);

  useEffect(() => {
    dispatch(checkHospital(props.order_by));
  }, [props.order_by]);

  const handleModalClose = () => {
    props.setPaymentModal(false);
  };

  // useEffect(() => {
  //   let options = paymentMode.map((reason) => ({
  //     label: reason.label,
  //     value: reason.value,
  //   }));
  //   setPayment(options);
  // }, []);

  useEffect(() => {
    let options = [...paymentMode];

    if (checker?.status === "success" && checker?.data?.receivable) {
      options.push({
        value: "receivable",
        label: `Receivables: ${checker?.data?.receivable}`,
      });
    }

    setPayment(options);
  }, [checker]);

  return (
    <>
      <Dialog
        open={props.paymentModal}
        onClose={handleModalClose}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            width: "80%",
            maxWidth: "700px",
            borderRadius: "10px",
            overflowY: "scroll",
          },
        }}
      >
        <div className="d-flex justify-content-between mt-3 mb-3 p-3">
          <p className={Styles.breadcumb} style={{ color: props.colors }}>
            <IssuesCloseOutlined
              style={{ fontSize: "35px" }}
              className="me-3"
            />
            <span>CLOSE ORDER</span>{" "}
          </p>
        </div>

        <DialogContent sx={{ padding: "30px" }}>
          <Formik
            initialValues={{
              title: "",
              order_id: "",
              details: "",
              payment:
                props.payment === "RECEIVABLES" ||
                props.payment === "Receivables"
                  ? props.payment
                  : "",
              pod: null,
            }}
            validate={(values) => {
              const errors = {};
              if (!values.details) {
                errors.details = "Kindly fill in payment details";
              }
              if (!values.payment) {
                errors.payment = "Payment mode is mandatory";
              }
              if (props.pod === null && !values.pod) {
                errors.pod = "POD is mandatory";
              }
              return errors;
            }}
            onSubmit={async (values) => {
              const formData = new FormData();
              formData.append("title", props.title);
              formData.append("order_id", props.order_id);
              formData.append("details", values.details);
              formData.append(
                "payment",
                values.payment?.value || props.payment
              );

              if (podFile) {
                formData.append("pod", podFile);
              }

              const response = await dispatch(closeOrder(formData));

              if (response.data.late === "Late") {
                props.setPaymentModal(false);
                setReason(true);
              } else {
                props.onClickYes();
                closeToast();
                setPodFile(null);
              }
            }}
          >
            {({
              handleChange,
              handleSubmit,
              values,
              handleBlur,
              errors,
              touched,
              setFieldValue,
            }) => (
              <Box
                component="form"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  width: "100%",
                }}
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit}
              >
                <div className="d-flex flex-column justify-content-between">
                  <h4 className="mb-3">
                    {props.title === "blood"
                      ? `${props.qty} ${props.qty > 1 ? "pints" : "pint"} of ${
                          props.product
                        } for ${props.name}`
                      : props.title === "oxygen"
                      ? `${props.qty} quantities of ${props.product} for ${props.name}`
                      : ""}
                  </h4>

                  {props?.pod === null ? (
                    <>
                      <button
                        type="button"
                        className={`shadow-none ${Styles.actionBtn} ${Styles.confirm}`}
                        style={{
                          width: "40%",
                          background: "green",
                          padding: "10px 20px",
                          borderRadius: "8px",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                        onClick={() => document.getElementById("pod")?.click()}
                      >
                        {podFile
                          ? "Change Proof of Delivery"
                          : "Upload Proof of Delivery"}
                      </button>

                      <input
                        id="pod"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(e) => handleFileChange(e, setFieldValue)}
                      />
                      {errors.pod && touched.pod ? (
                        <p className="text-danger mt-1">{errors.pod}</p>
                      ) : null}

                      {podFile && (
                        <p style={{ marginTop: "10px" }}>
                          Selected file: <strong>{podFile.name}</strong>
                        </p>
                      )}
                    </>
                  ) : (
                    <p>There is a Proof of Delivery for this order</p>
                  )}

                  {podFile && (
                    <img
                      src={URL.createObjectURL(podFile)}
                      alt="POD Preview"
                      style={{
                        width: "150px",
                        marginTop: "10px",
                        borderRadius: "8px",
                      }}
                    />
                  )}
                </div>

                {/* Payment Mode Dropdown */}
                {props.payment === "RECEIVABLES" ||
                props.payment === "Receivables" ? (
                  <div>
                    <p
                      style={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: props.colors,
                      }}
                    >
                      {props.payment}
                    </p>
                  </div>
                ) : (
                  <div>
                    <SelectField
                      name="payment"
                      options={payments}
                      onChange={setFieldValue}
                      placeholder="Select Payment Mode"
                      onBlur={handleBlur}
                    />
                    {errors.payment && touched.payment ? (
                      <p className="text-danger mt-1">{errors.payment}</p>
                    ) : null}
                  </div>
                )}

                {/* Payment Details Input */}
                <div>
                  <Form.Control
                    as="textarea"
                    onChange={handleChange}
                    name="details"
                    placeholder="Enter Payment Details"
                    style={{
                      height: "120px",
                      width: "100%",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  />
                  {errors.details && touched.details ? (
                    <p className="text-danger mt-1">{errors.details}</p>
                  ) : null}
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-end mt-4">
                  <button
                    type="button"
                    className={`shadow-none ${Styles.actionBtn} ${Styles.confirm}`}
                    style={{
                      background: props.btnColor,
                      padding: "10px 20px",
                      borderRadius: "8px",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                    onClick={handleModalClose}
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className={`shadow-none ${Styles.actionBtn} ${Styles.reject}`}
                    style={{
                      background: props.btnColor,
                      padding: "10px 20px",
                      borderRadius: "8px",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </Box>
            )}
          </Formik>
        </DialogContent>
      </Dialog>

      {/* Reason Modal */}
      <Reason
        reason={reason}
        setReason={setReason}
        title={props.title}
        orderId={props.order_id}
      />
    </>
  );
}
